export default __webpack_public_path__ + "static/media/bird.f373336c.png";